module.exports = __webpack_public_path__ + "img/map_toilet_3.f2634791.png";